<template>
    <div class="con-btn">

        <div class="row-content mb10 mt10">
            <div class="row-item column-layout flex">
                <div class="fl col-3">
                    <span>员工名称：</span>
                    <span>{{thisStaffName || '无'}}</span>
                    <a class="swb-btn  swb-btn-link" v-if="isSkip" @click="staffForselect()">选择</a>
                </div>
                <div class="fl col-3">
                    <span>员工所在公司：</span>
                    <span>{{thisComName || '无'}}</span>
                </div>
                <div class="fl col-3">
                    <span>被订阅公司：</span>
                    <span>{{thisComName || '无'}}</span>
                </div>
                <div class="fl col-3">
                    <a class="swb-btn  swb-btn-link" v-if="thisStaffId != null" @click="showSubscrList()">查看已订阅</a>
                </div>
            </div>
        </div>

        <div class="msg-subscr-msanage" v-for="bizTopic in bizTopicList">
            <div v-if="bizTopic.bizEventMsgList != null && bizTopic.bizEventMsgList.length > 0">
                <div class="message-tips">
                    <div class="inline-block mr20">
                        <span class="font-gray1">主题：</span>
                        <el-checkbox v-model="bizTopic.checked" @change="selectBizTopicMethod(bizTopic.id)">{{bizTopic.name}}</el-checkbox>
                    </div>
                    <div class="inline-block mr20">
                        <span>商品分类：</span>
                        <el-checkbox v-model="bizTopic.goodsCatForAll" @change="goodsCatSet(bizTopic.id)">全部分类</el-checkbox>
                        <a v-if="!bizTopic.goodsCatForAll" class="swb-btn-link" @click="goodsCatForselect(bizTopic.id)">选择</a>
                    </div>
                    <div class="inline-block mr20">
                        <span>服务分类：</span>
                        <el-checkbox v-model="bizTopic.servcCatForAll" @change="servcCatSet(bizTopic.id)">全部分类</el-checkbox>
                        <a v-if="!bizTopic.servcCatForAll" class="swb-btn-link" @click="servcCatForselect(bizTopic.id)">选择</a>
                    </div>
                </div>
                <div v-if="(bizTopic.goodsCatList != null && bizTopic.goodsCatList.length > 0) || (bizTopic.servcCatList != null && bizTopic.servcCatList.length > 0)">
                    <div class="pb10" v-if="bizTopic.goodsCatList != null && bizTopic.goodsCatList.length > 0">
                        <span>已选商品分类：</span>
                        <span class="mr10 mb10" v-for="goodsCat in bizTopic.goodsCatList">{{goodsCat.catName}}</span>
                    </div>
                    <div class="pb10" v-if="bizTopic.servcCatList != null && bizTopic.servcCatList.length > 0">
                        <span>已选服务分类：</span>
                        <span class="mr10 mb10" v-for="servcCat in bizTopic.servcCatList">{{servcCat.catName}}</span>
                    </div>
                </div>
                <div class="message-body">
                    <ul class="native-table">
                        <li class="table-tr">
                            <div class="table-th" style="width: 150px; text-align: left;">消息名称</div>
                            <div class="table-th" style="text-align: left;">消息内容</div>
                            <div class="table-th" style="width: 700px;">&nbsp;</div>
                        </li>
                        <li class="table-tr" :class="bizEventMsg.vipLevel > currentVipLevel ? 'vipCtrl' : ''" v-for="bizEventMsg in bizTopic.bizEventMsgList">
                            <div class="table-td" style="text-align: left;">
                                <el-checkbox v-model="bizEventMsg.checked" :disabled="bizEventMsg.vipLevel > currentVipLevel" class="ml20" @change="selectEventMsg(bizTopic.id, bizEventMsg.id)">
                                    <span>{{bizEventMsg.name}}</span>
                                </el-checkbox>
                            </div>
                            <div class="table-td" style="text-align: left;">{{bizEventMsg.renderContent}}</div>
                            <div class="table-td" style="text-align: left;">
                                 <span v-if="bizEventMsg.siteMsgFlag">
                                <el-checkbox class="ml20" v-model="bizEventMsg.selectSiteMsgFlag" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="changeSaveFlag">站内信</el-checkbox>
                            </span>
                                <span v-if="bizEventMsg.emailFlag">
                                <el-checkbox class="ml20" v-model="bizEventMsg.selectEmailFlag" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="changeSaveFlag">邮件</el-checkbox>
                            </span>
                                <span v-if="bizEventMsg.wxFlag">
                                <el-checkbox class="ml20" v-model="bizEventMsg.selectWxFlag" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="changeSaveFlag">微信</el-checkbox>
                            </span>
                                <span v-if="bizEventMsg.selectWxFlag">
                                <el-checkbox class="ml20" v-model="bizEventMsg.selectMiniApp" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="setMiniAppInfo(bizTopic.id, bizEventMsg.id)">选择小程序</el-checkbox>
                            </span>
                                <div v-if="bizEventMsg.selectMiniApp && bizEventMsg.selectWxFlag" class="inline-block">
                                    <div class="inline-block ml10" v-if="bizEventMsg.bizEventMsgAppList != null && bizEventMsg.bizEventMsgAppList.length > 0">
                                        <el-radio-group v-model="bizEventMsg.appAlias" :disabled="bizEventMsg.vipLevel > currentVipLevel" @change="changeSaveFlag">
                                            <el-radio v-for="eventMsgApp in bizEventMsg.bizEventMsgAppList" :label="eventMsgApp.appAlias">
                                                <span>{{miniAppAliases[eventMsgApp.appAlias]}}</span>
                                            </el-radio>
                                        </el-radio-group>
                                    </div>
                                    <span class="font-red ml10" v-else>未设置小程序</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="form-toolbar">
            <!--<a class="swb-btn swb-btn-small swb-btn-primary mr10" @click="pageBack()">返回</a>-->
            <a class="swb-btn swb-btn-small" @click="saveEventMsgSubscr">保存</a>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import {
        openCategTreeMultiSelectDlg,
        openServcCategTreeMultiSelectDlg,
        openMerchtFusedGoodsCategSelectDlg,
        openMerchtFusedServcCategSelectDlg
    } from '../categ/selectDlg'
    import { openThisOrDownComStaffForSelectDlg } from '../orgStruct/selectDlg'
    //
    import bizMsgApi from '../../api/bizMsg'
    import userApi from '../../api/user'
    //
    import SwbShowSubscrList from './ShowSubscrList'
    Vue.regist(SwbShowSubscrList);
    //
    export default {
        name: 'swb-subscr-manage-list',
        // path: '/biz/event/msg/subscr/manage/list',
        props: ["staffId", "staffName", "comName"],
        desc: ' 消息批量订阅管理',
        data: function () {
            return {
                currentVipLevel: null,
                scopeEntity: [],
                //
                selectBizTopicList: [],
                miniAppAliases: {},
                //
                bizTopicList: [],
                thisStaffId: null,
                thisStaffName: null,
                isSkip: true,
                //
                vipLevel: {},
                saveFlag: false,
            }
        },
//        watch: {
//            '$route': 'fetchData'
//        },
        created: function () {
            //
            this.fetchData();
        },
        methods: {
            fetchData: function () {    // 监听route变化重新加载界面...
                // this.thisStaffId = this.$route.query.staffId || null;
                // this.thisStaffName = this.$route.query.staffName || null;
                this.thisStaffId = this.staffId || null;
                this.thisStaffName = this.staffName || null;
                this.thisComName = this.comName || null;
                if(this.thisStaffId != null) {  // 非跳转来的
                    this.isSkip = false;
                }
                //
                this.miniAppAliases = {
                    "servicerEngin": "服务商服务工程师",
                    "servicerServc": "服务商服务管理"
                };
                //
                this.vipLevel = getEnumMap("vipLevel", "value2text");
                // 获取当前商户信息
                this.getCurrentUserInfo();
            },
            getCurrentUserInfo: function () {
                let self = this;
                let data = {};
                userApi.getUserInfoByContext(data, function (result) {
                    if(result.type === "info") {
                        let userInfo = result.data;
                        let scopeEntity = userInfo.scopeEntity;
                        //
                        self.currentVipLevel = scopeEntity.vipLevel;
                        self.scopeEntity = scopeEntity;
                        //
                        self.getBizTopicList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 选择员工
            staffForselect: function () {
                let self = this;
                openThisOrDownComStaffForSelectDlg(this.eventMsgId, function (resultData) {
                    self.thisStaffId = resultData.id;
                    self.thisStaffName = resultData.name;
                    self.thisComName = resultData.comName;
                    //
                    self.saveFlag = true;
                    // self.existMsgSubscr();
                });
            },
            //
            getBizTopicList: function () {  // 获取主题-事件
                let self = this;
                let postData = {};
                let theLoad = MsgBox.loading();
                bizMsgApi.getBizTopicList(postData, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let bizTopicList = result.data;
                        if(bizTopicList != null && bizTopicList.length > 0) {
                            //
                            bizTopicList.forEach(function (bizTopic) {
                                // 设置默认值
                                bizTopic.checked = false;   // 是否选中
                                bizTopic.goodsCatForAll = true;
                                bizTopic.servcCatForAll = true;
                                bizTopic.goodsCatList = [];
                                bizTopic.servcCatList = [];
                                //
                                let bizEventMsgList = bizTopic.bizEventMsgList;
                                if(bizEventMsgList != null && bizEventMsgList.length > 0) {     // 事件
                                    bizEventMsgList.forEach(function (bizEventMsg) {
                                        //
                                        bizEventMsg.checked = false;   // 是否选中
                                        // 支持方式 -  支持及默认选中
                                        bizEventMsg.selectSiteMsgFlag = bizEventMsg.siteMsgFlag; //
                                        bizEventMsg.selectEmailFlag = bizEventMsg.siteMsgFlag;
                                        bizEventMsg.selectWxFlag = bizEventMsg.siteMsgFlag;
                                        //
                                        bizEventMsg.selectMiniApp = true;
                                        //
                                        self.getBizEventMsgAppList(bizEventMsg, theLoad);
                                    });
                                }
                            });
                        }
                        self.bizTopicList = bizTopicList;
                    } else {
                        MsgBox.warning(result.message);
                        theLoad.close();
                    }
                });
            },
            getBizEventMsgAppList: function (bizEventMsg, theLoad) {    // 获取每个事件支持的小程序
                let self = this;
                let postData = {};
                postData.eventMsgId = bizEventMsg.id;
                postData.appMerchantType = getEnumInfoWith('merchantType', 'name', 'Servicer').value;
                //
                bizMsgApi.getBizEventMsgAppList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let bizEventMsgAppList = result.data;
                        //
                        if(bizEventMsgAppList != null && bizEventMsgAppList.length > 0) {
                            // 默认选中第一个
                            let bizEventMsgApp = bizEventMsgAppList[0];
                            bizEventMsg.appAlias = bizEventMsgApp.appAlias || null;
                        } else {
                            bizEventMsg.appAlias = null;
                            bizEventMsg.selectMiniApp = false;
                        }
                        //
                        bizEventMsg.bizEventMsgAppList = bizEventMsgAppList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            // ---------------------------------- 分类信息 --------------------------------
            goodsCatSet: function (topicId) {
                this.saveFlag = true;
                let bizTopicInfo = this.getCurBizTopicInfo(topicId);
                //
                if(bizTopicInfo.goodsCatForAll) {
                    bizTopicInfo.goodsCatList = [];
                }
            },
            goodsCatForselect: function (topicId) {
                let self = this;
                let bizTopicInfo = this.getCurBizTopicInfo(topicId);
                //
                let displayDataList = bizTopicInfo.goodsCatList || [];
                let postData = {
                    multiSelect: true,
                };
                openMerchtFusedGoodsCategSelectDlg(postData, displayDataList, function (result) {
                    self.saveFlag = true;
                    let goodsCatList = [];
                    if(result.type == 'info') {
                        let resultData = result.data;
                        for(let i = 0; i < resultData.length; i++) {
                            let data = resultData[i];
                            let goodsCat = {};
                            goodsCat.catId = data.catId;
                            goodsCat.catId1 = data.catId1;
                            goodsCat.catId2 = data.catId2;
                            goodsCat.catId3 = data.catId3;
                            goodsCat.catName = data.catName;
                            goodsCatList.push(goodsCat);
                        }
                    }
                    bizTopicInfo.goodsCatList = Utils.merge([], goodsCatList);
                });
            },
            // 服务分类选择
            servcCatSet: function (topicId) {// 重置选择的分类信息
                let bizTopicInfo = this.getCurBizTopicInfo(topicId);
                //
                this.saveFlag = true;
                if(bizTopicInfo.servcCatForAll) {
                    bizTopicInfo.servcCatList = [];
                }
            },
            servcCatForselect: function (topicId) {
                let self = this;
                let bizTopicInfo = this.getCurBizTopicInfo(topicId);
                //
                let displayDataList = bizTopicInfo.servcCatList || [];
                let postData = {
                    multiSelect: true,
                };
                openMerchtFusedServcCategSelectDlg(postData, displayDataList, function (result) {
                    self.saveFlag = true;
                    let servcCatList = [];
                    if(result.type == 'info') {
                        let resultData = result.data;
                        for(let i = 0; i < resultData.length; i++) {
                            let data = resultData[i];
                            let servcCat = {};
                            servcCat.catId = data.catId;
                            servcCat.catId1 = data.catId1;
                            servcCat.catId2 = data.catId2;
                            servcCat.catId3 = data.catId3;
                            servcCat.catName = data.catName;
                            servcCatList.push(servcCat);
                        }
                    }
                    bizTopicInfo.servcCatList = Utils.merge([], servcCatList);
                });
            },
            getCurBizTopicInfo: function (topicId, msgId) {    // 获取当前操作主题信息
                let bizTopicInfo = null;
                let bizTopicList = this.bizTopicList || [];
                bizTopicList.forEach(function (bizTopic) {
                    if(bizTopic.id == topicId) {
                        bizTopicInfo = bizTopic;
                    }
                });
                if(bizTopicInfo == null) {
                    MsgBox.warning("主题事件信息异常！");
                    return;
                }
                if(!Utils.isNoB(msgId)) {
                    let eventMsgList = bizTopicInfo.bizEventMsgList || [];
                    eventMsgList.forEach(function (eventMsg) {
                        if(eventMsg.id == msgId) {
                            bizTopicInfo.selectEventMsg = eventMsg;
                        }
                    })
                }
                return bizTopicInfo;
            },
            // ---------------------------------- 分类信息END --------------------------------
            setMiniAppInfo: function (topicId, msgId) {   // 支持微信
                this.saveFlag = true;
//                let bizTopicInfo = this.getCurBizTopicInfo(topicId, msgId);
//                let selectEventMsg = bizTopicInfo.selectEventMsg;   //
//                //
//                if(!selectEventMsg.selectMiniApp) {
//                    selectEventMsg.appAlias = " ";
//                }
//                console.log(this.selectBizTopicList);
            },

            // 单选订阅的事件 - 方法
            selectEventMsg: function (topicId, msgId) {
                this.saveFlag = true;
                let bizTopicInfo = this.getCurBizTopicInfo(topicId, msgId);
                let selectEventMsg = bizTopicInfo.selectEventMsg;   //
                //
                let selectBizTopicList = this.selectBizTopicList || [];
                if(selectBizTopicList != null && selectBizTopicList.length > 0) {
                    let topicIds = selectBizTopicList.pluck("id");
                    //
                    let topicIndex = topicIds.indexOf(bizTopicInfo.id);
                    // 选中数据是否包含当前选中的 主题
                    if(topicIndex >= 0) {
                        selectBizTopicList.forEach(function (bizTopic) {   // 主题集合
                            if(bizTopic.id == bizTopicInfo.id) {
                                let bizEventMsgDtos = bizTopic.bizEventMsgDtos || [];
                                if(bizEventMsgDtos != null && bizEventMsgDtos.length > 0) {
                                    let eventMsgId = selectEventMsg.id;
                                    //
                                    let selectEventMsgIds = bizEventMsgDtos.pluck("id");
                                    let index = selectEventMsgIds.indexOf(eventMsgId);
                                    if(index <= -1) {
                                        bizEventMsgDtos.push(selectEventMsg);
                                    } else {
                                        bizEventMsgDtos.splice(index, 1);
                                    }
                                } else {
                                    // 新建一个事件的集合
                                    let bizEventMsgDtos = [];
                                    bizEventMsgDtos.push(selectEventMsg);
                                    //
                                    bizTopic.bizEventMsgDtos = bizEventMsgDtos;
                                }
                            }
                        });
                    } else {
                        // 新建事件集合
                        let bizEventMsgDtos = [];
                        bizEventMsgDtos.push(selectEventMsg);
                        //
                        let topicInfo = {};
                        topicInfo.id = bizTopicInfo.id;
                        topicInfo.name = bizTopicInfo.name;
                        topicInfo.bizEventMsgDtos = bizEventMsgDtos;
                        //
                        this.selectBizTopicList.push(topicInfo);
                    }
                } else {
                    // 新定义一个事件集合
                    let bizEventMsgDtos = [];
                    bizEventMsgDtos.push(selectEventMsg);
                    // 定义主题   ---- 将可修改的数据放到-提交数据时设置 ps: 分类信息等...
                    let topicInfo = {};
                    topicInfo.id = bizTopicInfo.id;
                    topicInfo.name = bizTopicInfo.name;
                    topicInfo.bizEventMsgDtos = bizEventMsgDtos;
                    //
                    let selectBizTopic = [];
                    selectBizTopic.push(topicInfo);
                    //
                    this.selectBizTopicList = selectBizTopic;
                }
                console.log(this.selectBizTopicList);
            },
            // 选择主题 - 方法
            selectBizTopicMethod: function (topicId) {
                this.saveFlag = true;
                let bizTopicInfo = this.getCurBizTopicInfo(topicId);
                // 获取当前主题下所有的事件
                let bizEventMsgList = bizTopicInfo.bizEventMsgList;
                //
                let selectBizTopicList = this.selectBizTopicList;
                let topicIds = selectBizTopicList.pluck("id");
                //
                if(bizTopicInfo.checked) {
                    //
                    let currentVipLevel = this.currentVipLevel;
                    let selectEventMsgList = [];
                    if(bizEventMsgList != null && bizEventMsgList.length > 0) {// 去除不符vip等级的事件
                        bizEventMsgList.forEach(function (eventMsg) {
                            if(eventMsg.vipLevel <= currentVipLevel) {
                                //
                                eventMsg.checked = true;
                                selectEventMsgList.push(eventMsg);
                            }
                        })
                    }
                    //
                    let topicInfo = {};
                    topicInfo.id = topicId;
                    topicInfo.name = bizTopicInfo.name;
                    topicInfo.bizEventMsgDtos = selectEventMsgList;
                    //
                    let index = topicIds.indexOf(topicId);
                    if(index >= 0) {     // 选中的已包含当前主题
                        // 包含-覆盖掉旧数据
                        selectBizTopicList[index] = topicInfo;
                    } else {
                        // 不包含-全部新增
                        selectBizTopicList.push(topicInfo);
                    }
                } else {    // 取消选中...
                    let index = topicIds.indexOf(topicId);
                    selectBizTopicList.splice(index, 1);
                    //
                    if(bizEventMsgList != null && bizEventMsgList.length > 0) {
                        bizEventMsgList.forEach(function (eventMsg) {
                            eventMsg.checked = false;
                        })
                    }
                }
                console.log(this.selectBizTopicList);
            },

            // 订阅前 检查是否满足vip级别
            checkBizEventMsgForVip: function (id, name) {
                let self = this;
                let postData = {};
                postData.id = id;
                let theLoad = MsgBox.loading();
                bizMsgApi.checkBizEventMsgForVip(postData, function (result, jqXhr) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let ok = result.data;
                        if(ok) {
                            // 调用 订阅的弹出框
                            self.msgSubscrDlg(id);
                        } else {
                            MsgBox.warning("您不满足【" + name + "】所要求的的VIP等级！");
                        }
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            changeSaveFlag: function () {
                this.saveFlag = true;
            },
            // 订阅界面弹框
            saveEventMsgSubscr: function () {
                let self = this;
                let selectBizTopicList = this.selectBizTopicList;
                if(Utils.isNoB(self.thisStaffId)) {
                    MsgBox.warning("请选择订阅者！");
                    return;
                }
                if(selectBizTopicList == null || selectBizTopicList.length <= 0) {
                    MsgBox.warning("请选择要订阅的事件！");
                    return;
                }
                // 设置最新-分类信息 + 校验
                for(let i = 0; i < selectBizTopicList.length; i++) {
                    let bizTopic = selectBizTopicList[i];   // 只有id，name 等信息
                    let bizTopicInfo = self.getCurBizTopicInfo(bizTopic.id);
                    //
                    let bizEventMsgDtos = bizTopic.bizEventMsgDtos || [];
                    if(bizEventMsgDtos != null && bizEventMsgDtos.length > 0) {
                        //
                        for(let i = 0; i < bizEventMsgDtos.length; i++) {
                            let bizEventMsg = bizEventMsgDtos[i];
                            if(!bizEventMsg.selectMiniApp) {    // 不选择小程序 - 小程序设置为null
                                bizEventMsg.appAlias = "";
                            } else {
                                // 选择小程序 - 校验小程序不可为空！
                                if(Utils.isNoB(bizEventMsg.appAlias)) {
                                    MsgBox.warning("【" + bizEventMsg.name + "】未设置小程序！");
                                    return;
                                }
                            }
                        }
                    } else {
                        MsgBox.warning("请选择要订阅的事件！");
                        return;
                    }
                    // 商品分类
                    let goodsRelated = bizTopicInfo.goodsRelated;
                    let goodsCatForAll = bizTopicInfo.goodsCatForAll;
                    bizTopic.goodsCatForAll = goodsCatForAll;
                    bizTopic.goodsRelated = goodsRelated;
                    //
                    if(goodsCatForAll) {   // 是否全选
                        bizTopic.goodsCatIds = [];
                    } else {
                        bizTopic.goodsCatIds = bizTopicInfo.goodsCatList.pluck("catId");
                    }
                    // 服务分类
                    let servcRelated = bizTopicInfo.servcRelated;
                    let servcCatForAll = bizTopicInfo.servcCatForAll;
                    bizTopic.servcCatForAll = servcCatForAll;
                    bizTopic.servcRelated = servcRelated;
                    //
                    if(servcCatForAll) {
                        bizTopic.servcCatIds = [];
                    } else {
                        bizTopic.servcCatIds = bizTopicInfo.servcCatList.pluck("catId");
                    }
                    //
                    if(bizTopic.goodsRelated || bizTopic.servcRelated) {    // 是否支持分类信息
                        if(!goodsCatForAll && !servcCatForAll && bizTopic.goodsCatIds <= 0 && bizTopic.servcCatIds.length <= 0) {
                            MsgBox.warning("主题【" + bizTopic.name + "】未设置分类信息！");
                            return;
                        }
                    }
                }
                //
                let bizEventMsgSubscrDto = {};
                bizEventMsgSubscrDto.staffId = self.thisStaffId;
                bizEventMsgSubscrDto.bizTopicDtos = selectBizTopicList;
                //
                // console.log(bizEventMsgSubscrDto);\
                let saveFlag = self.saveFlag;
                if(saveFlag) {
                    console.log("------------ 请求后台保存！！ ------------");
                    this.saveBizEventMsgSubscrList(bizEventMsgSubscrDto);
                } else {
                    console.log("------------ 未修改信息，不请求后台！！ ------------");
                    MsgBox.success("订阅成功！");
                }
            },
            saveBizEventMsgSubscrList: function (bizEventMsgSubscrDto) {
                let self = this;
                let theLoading = MsgBox.loading();
                bizMsgApi.saveBizEventMsgSubscrList(bizEventMsgSubscrDto, function (result) {
                    theLoading.close();
                    if(result.type === "info") {
                        self.saveFlag = false;
                        MsgBox.success("订阅成功！");
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            showSubscrList: function () { // 按照层级结构查看已订阅信息
                let self = this;
                //
                let theDlg = Vue.$showDialog({
                    title: "已订阅消息",
                    width: 800,
                    height: 700,
                    okVisible: false,
                    showCloseBtn: true,
                    okClicked: false,
                    cancelText: '关闭',
                    template: '<swb-show-biz-event-subscr-list :staffId="staffId" ref="swb_show_biz_event_subscr_list"></swb-show-biz-event-subscr-list>',
                    data: {
                        staffId: self.thisStaffId
                    },
                    methods: {}
                });
            }
        }
    }
</script>

<style>

    .table-tr.vipCtrl:after {
        content: 'vip等级不满足';
        position: absolute;
        left: 20px;
        width: 100px;
        height: 30px;
        display: block;
        text-align: center;
        line-height: 30px;
        background-color: #fff6f6;
        border: 1px solid #D71718;
        color: black;
        opacity: 0.5;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        transform: rotate(-16deg);
        -ms-transform: rotate(-16deg); /* IE 9 */
        -moz-transform: rotate(-16deg); /* Firefox */
        -webkit-transform: rotate(-16deg); /* Safari 和 Chrome */
        -o-transform: rotate(-16deg); /* Opera */
    }

</style>




// WEBPACK FOOTER //
// src/compo/bizMsg/SubscrManageList.vue